import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { brandPropTypes, productShape } from "app/utils/propTypes";
import { MerchandisingCard } from "./MerchandisingCard";
import { isAnyListingFilterActive } from "app/pages/Listing/productsSelector";
import ProductCard from "@brand/Product/default/Product";
import { LISTING_ITEM_TYPES } from "app/constants";

class ListingItemCardComponent extends React.Component {
	render() {
		const { product = {}, resolution, isAnyListingFilterActive, brand } = this.props;
		return product.type === LISTING_ITEM_TYPES.PRODUCT ? (
			<ProductCard resolution={resolution} product={product} brand={brand} />
		) : (
			<MerchandisingCard
				product={product}
				resolution={resolution}
				isAnyListingFilterActive={isAnyListingFilterActive}
			/>
		);
	}
}

const mapStateToProps = state => {
	return {
		resolution: state.resolution,
		brand: state.brand.code,
		isAnyListingFilterActive: isAnyListingFilterActive(state),
	};
};

ListingItemCardComponent.propTypes = {
	brand: brandPropTypes,
	product: productShape,
	resolution: PropTypes.string,
	isAnyListingFilterActive: PropTypes.bool,
};

export const ListingItemCard = connect(mapStateToProps)(ListingItemCardComponent);
